import React from "react";

export const QCard = React.forwardRef(
  ({ className = "", interactive = true, children, ...rest }, ref) => (
    <div
      ref={ref}
      className={`bg-white border border-border rounded-xl p-7 md:p-8 shadow-sm ${
        interactive
          ? "transition-[box-shadow,transform] duration-200 hover:shadow-md hover:-translate-y-0.5"
          : ""
      } ${className}`}
      {...rest}
    >
      {children}
    </div>
  )
);
QCard.displayName = "QCard";

export default QCard;
